import { render, staticRenderFns } from "./ConsultaInventarioAgotado.vue?vue&type=template&id=35234811"
import script from "./ConsultaInventarioAgotado.vue?vue&type=script&lang=js"
export * from "./ConsultaInventarioAgotado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports